import React, { useState } from 'react';
import { Avatar } from '@material-ui/core';
import {
  formatNumberWithCommas,
  getFirstLastNameLetters,
} from '../../../../Helper';
import { AEDIcon } from '../../../../assets/icons';
export const WalletTransactionsHeaderData = (isDarkMode = false, styles) => [
  {
    id: 1,
    minWidth: 253,
    headerName: 'Agent name',
    field: 'agentName',
    sortable: false,
    filterable: false,
    renderCell: (item) => {
      return (
        <div className={styles.agentNameWrapper}>
          <Avatar className={styles.avatar}>
            {getFirstLastNameLetters(item.row.agentName)}
          </Avatar>
          <label
            style={{
              fontWeight: 500,
              color: !isDarkMode ? '#101828' : '#F5F5F6',
            }}
          >
            <span style={{ display: 'block' }}>{item?.row?.agentName}</span>
          </label>
        </div>
      );
    },
  },
  {
    id: 2,
    minWidth: 253,
    headerName: 'Email',
    field: 'email',
    sortable: false,
    filterable: false,
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: !isDarkMode ? '#101828' : '#F5F5F6',
            paddingLeft: '6px',
          }}
        >
          <span style={{ display: 'block' }}>{item?.row?.email}</span>
        </label>
      );
    },
  },
  {
    id: 3,
    minWidth: 253,
    headerName: 'Transaction type',
    field: 'type',
    sortable: false,
    filterable: false,
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 700,
            color: !isDarkMode ? '#475467' : '#94969C',
            paddingLeft: '6px',
          }}
        >
          <span style={{ display: 'block' }}>{item?.row?.type}</span>
        </label>
      );
    },
  },
  {
    id: 4,
    minWidth: 253,
    headerName: 'Minutes',
    field: 'minutes',
    sortable: false,
    filterable: false,
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            color: item.row.minutes > 0 ? '#079455' : '#D92D20',
            paddingLeft: '6px',
          }}
        >
          <span style={{ display: 'block' }}>{item?.row?.minutes}</span>
        </label>
      );
    },
  },
  {
    id: 5,
    minWidth: 253,
    headerName: 'Amount',
    field: 'amount',
    sortable: false,
    filterable: false,
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 600,
          fontSize: '16px',
          display: 'flex',
          alignItems: 'center',
          color: isDarkMode ? '#F5F5F6' : '#101828',
          gap: '8px',
          paddingLeft: '6px',
        }}
      >
        {item?.row?.amount ? (
          <AEDIcon
            width='20'
            height='20'
            aspect-ratio='1/1'
            fill={isDarkMode ? '#94969C' : '#475467'}
          />
        ) : (
          ''
        )}
        {typeof item?.row?.amount === 'number'
          ? `${formatNumberWithCommas(item.row.amount)} `
          : '--'}
      </label>
    ),
  },
  {
    id: 6,
    minWidth: 253,
    headerName: 'Balance Before',
    field: 'balanceBefore',
    sortable: false,
    filterable: false,
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          color: !isDarkMode ? '#101828' : '#F5F5F6',
          paddingLeft: '6px',
        }}
      >
        <span style={{ display: 'block' }}>{item?.row?.balanceBefore}</span>
      </label>
    ),
  },
  {
    id: 7,
    minWidth: 253,
    headerName: 'Balance After',
    field: 'balanceAfter',
    sortable: false,
    filterable: false,
    renderCell: (item) => (
      <label
        style={{
          fontWeight: 500,
          color: !isDarkMode ? '#101828' : '#F5F5F6',
          paddingLeft: '6px',
        }}
      >
        <span style={{ display: 'block' }}>{item?.row?.balanceAfter}</span>
      </label>
    ),
  },
  {
    id: 8,
    minWidth: 253,
    headerName: 'Date & time ',
    field: 'createdOn',
    sortable: false,
    filterable: false,
    renderCell: (item) => {
      const createdOn = item?.row?.createdOn || '';
      const [datePart, timePart] = createdOn.split(' . ');

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '6px',
          }}
        >
          <span style={{ fontWeight: 500, color: '#101828' }}>{datePart}</span>
          <span style={{ fontWeight: 400, color: '#475467' }}>{timePart}</span>
        </div>
      );
    },
  },
];
